import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=5bd12de7&scoped=true&"
import script from "./mainFooter.vue?vue&type=script&lang=js&"
export * from "./mainFooter.vue?vue&type=script&lang=js&"
import style0 from "./mainFooter.vue?vue&type=style&index=0&id=5bd12de7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd12de7",
  null
  
)

export default component.exports